import React from 'react';
import {useIsomorphicLayoutEffect} from '@packages/systems/spring-hooks';

import {Text} from '../../Text';
import {useModal} from '../ModalProvider';

import type {TextProps} from '../../Text';

type ModalTitleProps = {
  /**
   * Contents of the Modal title.
   */
  children?: React.ReactNode;
} & TextProps;

export const ModalTitle = React.forwardRef<HTMLElement, ModalTitleProps>(
  ({children, ...props}: ModalTitleProps, ref) => {
    const {setModalTitleId, modalTitleId} = useModal();

    const id = React.useId();

    useIsomorphicLayoutEffect(() => {
      // This lets us set the modal title id in the context, or here if it isn't already set.
      setModalTitleId((definedId) => (definedId ? definedId : id));
      return () => setModalTitleId(undefined);
    }, [id, setModalTitleId]);

    return (
      <Text {...props} font="title" id={modalTitleId ?? id} ref={ref}>
        {children}
      </Text>
    );
  }
);

ModalTitle.displayName = 'ModalTitle';

export default ModalTitle;
